var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_2546)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_66_2546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07196 1.31095C7.40786 0.474475 8.592 0.474477 8.9279 1.31095L10.3522 4.85784C10.4952 5.21404 10.8296 5.45693 11.2125 5.4829L15.026 5.74147C15.9253 5.80245 16.2912 6.92863 15.5995 7.50658L12.6663 9.95724C12.3718 10.2034 12.2441 10.5964 12.3377 10.9686L13.2702 14.6753C13.4901 15.5495 12.5321 16.2455 11.7687 15.7662L8.53164 13.7339C8.20654 13.5298 7.79332 13.5298 7.46822 13.7339L4.2311 15.7662C3.46769 16.2455 2.5097 15.5495 2.72962 14.6753L3.66212 10.9686C3.75576 10.5964 3.62807 10.2034 3.3335 9.95724L0.400355 7.50657C-0.291375 6.92863 0.0745456 5.80245 0.973875 5.74147L4.7873 5.4829C5.17028 5.45693 5.50459 5.21404 5.64763 4.85784L7.07196 1.31095Z",
    fill: "#ECD829"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_2546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_66_2546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star2.b6169a139db0958bb30c84f0b6bd161e.svg";
export { ForwardRef as ReactComponent };